<template>
  <Modal title="Title" v-model="showFormModal" class-name="card-modal" :width="900">
    <div slot="header">
      <h4>{{title}}</h4>
    </div>
    <Form ref="exportForm" :model="exportForm" :label-width="100" border shadow>
      <Row class="widget-container">
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem v-for="(emailAddress, i) in exportForm.emails"
                    :key="i"
                    :label="'E-Mail ' + i"
                    :prop="'emails[' + i + '].emailAddress'"
                    :rules="[{required: true, message: 'Email Address ' + i +' cannot be empty', trigger: 'blur'},
                      {type: 'email', message: 'Incorrect email format', trigger: 'blur'}]">
            <Input v-model="exportForm.emails[i].emailAddress" style="width: 400px"></Input>
            <Icon type="ios-close-circle-outline" color="#9b3035"
                  title="Delete E-Mail" size="24" @click="removeEmail(i)"/>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <Button type="success" @click="addEmail" icon="ios-add">Add E-Mail</Button>
        </i-col>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </Row>
    </Form>
    <div slot="footer">
      <Button size="large"
              :disabled="disableButtons"
              @click="handleReset;showFormModal=false"
              style="margin-left: 8px"
              type="error">
        Cancel
      </Button>
      <Button size="large" :disabled="exportForm.emails.length==0||disableButtons"
              @click="handleSend"
              class="submit"
              type="success">
        Send
      </Button>
    </div>
  </Modal>
</template>

<script>
  import {sendEmail} from "../../services/LeadForms.service";

  export default {
    data() {
      return {
        action: 'add',
        title: 'Send Xlsx as E-Mail',
        exportForm: {
          emails: [{
            emailAddress: null,
          }]
        },
        init: null,
        index: 0,
        showFormModal: false,
        spinShow: true,
        dataObject: {
          emails: null,
          companyId: null,
          eventId: null,
        },
        disableButtons: false,
      }
    },
    methods: {
      openExportForm() {
        this.handleReset();
        this.showFormModal = true;
        this.spinShow = false;
        this.exportForm.emails = [];
        this.exportForm.emails.push({emailAddress: ''});
      },
      setFormValue() {
      },
      handleReset() {
        this.$refs['exportForm'].resetFields();
      },
      handleSend() {
        const self = this;
        self.spinShow = true;
        self.disableButtons = true;
        self.$refs['exportForm'].validate((valid) => {
          if (valid) {
            let company = JSON.parse(localStorage.getItem('companies'))
              .filter(a => a.companyId == localStorage.getItem('selected_company'))[0];

            let event = JSON.parse(localStorage.getItem('events'))
              .filter(a => a.eventId == localStorage.getItem('selected_event'))[0];

            if (event && company) {
              self.dataObject.eventId = event.eventId;
              self.dataObject.companyId = company.companyId;
              self.dataObject.emails = "";
              if (self.exportForm.emails.length > 0) {
                self.exportForm.emails.map(a => {
                  self.dataObject.emails += a.emailAddress + '; ';
                });
              }
              sendEmail(self.dataObject)
                .then(item => {
                  self.spinShow = false;
                  self.showFormModal = false;
                  self.disableButtons = false;
                  this.$Message.success(item.data);
                })
                .catch(err => {
                  self.$Message.error(err);
                  self.spinShow = false;
                  self.disableButtons = false;
                });
            }
          } else {
            this.spinShow = false;
            self.disableButtons = false;
            this.$Message.error('Fail!');
          }
        })
      },
      addEmail() {
        this.exportForm.emails.push({emailAddress: ''});
      },
      removeEmail(index) {
        this.exportForm.emails.splice(index, 1);
      }
    }
  }
</script>

<style scoped>
  .ivu-input, .ivu-btn {
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/f_ExportData/exportForm.vue